var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tooltip)?_c('div',{staticClass:"ui-icon-wrapper"},[_c('span',{class:_vm.iconClasses,style:(_vm.iconStyles)}),_vm._v(" "),_c('div',{staticClass:"ui-icon-tooltip"},[_vm._v("\n        "+_vm._s(_vm.tooltip)+"\n    ")])]):_c('span',{class:_vm.iconClasses,style:(_vm.iconStyles)})
}
var staticRenderFns = []

export { render, staticRenderFns }